"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _delay = _interopRequireDefault(require("delay"));

var _dayjs = _interopRequireDefault(require("dayjs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const delayWithJitter = (ms, jitter = 0) => (0, _delay.default)(Math.floor(ms + Math.random() * jitter));

const fetchPricesInterval = async ({
  func,
  abortController,
  granularity,
  getJitter = () => 0,
  delay = 0,
  getCurrentTime = () => Date.now()
}) => {
  while (abortController ? !abortController.signal.aborted : true) {
    try {
      await func();
    } catch (err) {
      console.error(err);
    }

    const now = getCurrentTime();
    const untilEndOfPeriod = _dayjs.default.utc(now).endOf(granularity).valueOf() - now;
    await delayWithJitter(untilEndOfPeriod + delay, getJitter());
  }
};

var _default = fetchPricesInterval;
exports.default = _default;